// Tracks which shortfall orders the admin has already looked at (visited
// the Commandes page), independent of resolving the shortfall itself.
// Lets the sidebar badge reset to 0 on view while still lighting back up
// as soon as a genuinely new shortfall order comes in. Stored per employee
// account on the server (see seenNotifications.js), not in the browser.
import { fetchSeenIds, postSeenIds } from "./seenNotifications";

const KIND = "shortfall_order";
const LEGACY_STORAGE_KEY = "outex_seen_shortfall_order_ids";

export const SHORTFALL_ORDERS_SEEN_EVENT = "shortfallOrdersSeenChanged";

export const getSeenShortfallOrderIds = () => fetchSeenIds(KIND, LEGACY_STORAGE_KEY);

export const markShortfallOrdersSeen = async (ids = []) => {
  if (!ids.length) return;

  try {
    await postSeenIds(KIND, ids);
  } catch (err) {
    // Badge just won't reset this time, non-fatal
    console.error("Could not save seen shortfall orders:", err);
    return;
  }

  window.dispatchEvent(new Event(SHORTFALL_ORDERS_SEEN_EVENT));
};
